import { useCallback } from "react";
import styled from "@emotion/styled";
import { Virtuoso, VirtuosoProps } from "react-virtuoso";
import { shouldForwardProp } from "../Common.style";

type StyleBoxProps = {
  isLoading?: boolean;
  restTop?: number;
};

export const ScrollableListStyle = styled(Virtuoso, {
  shouldForwardProp: prop =>
    shouldForwardProp<StyleBoxProps>(["isLoading", "restTop"], prop),
})<StyleBoxProps>(({ restTop }) => ({
  overflow: "auto",
  display: "block",
  maxHeight: restTop && `calc(100dvh - ${restTop ? restTop : 0}px)`,
  position: "relative",
  height: "100%",
  padding: "0px",
  flexShrink: 1,
}));

interface ScrollListType extends VirtuosoProps<any, any> {
  isLoading?: boolean;
  restTop?: number;
  onScrollCallback?: () => void;
}

export const ScrollableList = ({
  isLoading = false,
  onScrollCallback,
  restTop = 200,
  ...props
}: ScrollListType) => {
  const loadMore = useCallback(() => {
    if (onScrollCallback) {
      return setTimeout(() => {
        onScrollCallback();
      }, 500);
    }
  }, [onScrollCallback]);

  return (
    <ScrollableListStyle
      isLoading={isLoading}
      endReached={loadMore}
      {...props}
    />
  );
};
